import { ArrowRight, Sparkles, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Cross-promotion section for GoCleaning.ie — a separate related business.
 * Intentionally distinct from the GoVans design so visitors clearly perceive it
 * as a partner service, not part of GoVans' own offering.
 */
export default function GoCleaningPromo() {
  return (
    <section
      data-testid="gocleaning-promo"
      aria-labelledby="gocleaning-promo-heading"
      className="py-20 md:py-24 bg-[#F1F5F9] border-y border-black/5"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="bg-white border border-black/10 p-8 md:p-12 rounded-sm">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-10 h-10 shrink-0 bg-[#0E9F6E]/10 rounded-sm flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-[#0E9F6E]" strokeWidth={1.75} aria-hidden="true" />
            </div>
            <div>
              <span className="text-[10px] sm:text-xs font-bold tracking-[0.2em] uppercase text-[#0E9F6E]">
                Related Service &mdash; A Separate Business
              </span>
              <h2
                id="gocleaning-promo-heading"
                className="text-2xl sm:text-3xl font-extrabold text-[#0A0A0A] tracking-tight mt-1"
              >
                Need Cleaning After Your Move?
              </h2>
            </div>
          </div>

          <p className="text-[#475569] text-sm md:text-base leading-relaxed mb-6">
            Moving out or into a new property? Our related local cleaning service,{" "}
            <strong className="text-[#0A0A0A]">GoCleaning</strong>, provides professional cleaning for apartments,
            houses, landlords and businesses across Dublin and surrounding areas.
          </p>

          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm text-[#475569] mb-8">
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#0E9F6E] rounded-full shrink-0" aria-hidden="true" />
              End of tenancy cleaning
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#0E9F6E] rounded-full shrink-0" aria-hidden="true" />
              Move-out cleaning
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#0E9F6E] rounded-full shrink-0" aria-hidden="true" />
              Deep cleaning
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#0E9F6E] rounded-full shrink-0" aria-hidden="true" />
              House and apartment cleaning
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#0E9F6E] rounded-full shrink-0" aria-hidden="true" />
              Office cleaning
            </li>
            <li className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#0E9F6E] rounded-full shrink-0" aria-hidden="true" />
              Commercial cleaning
            </li>
          </ul>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://gocleaning.ie"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gocleaning-visit-btn"
              className="flex-1 sm:flex-none"
            >
              <Button className="w-full sm:w-auto rounded-sm bg-[#0E9F6E] hover:bg-[#0B8A5F] text-white font-bold h-11 px-6 gap-2">
                Visit GoCleaning <ExternalLink className="w-4 h-4" aria-hidden="true" />
              </Button>
            </a>
            <a
              href="https://gocleaning.ie/contact"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="gocleaning-quote-btn"
              className="flex-1 sm:flex-none"
            >
              <Button
                variant="outline"
                className="w-full sm:w-auto rounded-sm border-[#0E9F6E] text-[#0E9F6E] hover:bg-[#0E9F6E] hover:text-white font-bold h-11 px-6 gap-2"
              >
                Get a Cleaning Quote <ArrowRight className="w-4 h-4" aria-hidden="true" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
